import { openBlock as e, createElementBlock as l, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, n = /* @__PURE__ */ t("path", {
  fill: "#D80027",
  d: "M0 20a19.9 19.9 0 0 0 2.432 9.565L20 31.305l17.568-1.74A19.911 19.911 0 0 0 40 20c0-3.465-.882-6.724-2.432-9.565L20 8.695l-17.568 1.74A19.91 19.91 0 0 0 0 20Z"
}, null, -1), c = /* @__PURE__ */ t("path", {
  fill: "#0052B4",
  d: "M2.432 10.435h35.136C34.176 4.218 27.581 0 20 0 12.419 0 5.824 4.218 2.432 10.435ZM20 40c7.58 0 14.176-4.218 17.568-10.435H2.432C5.824 35.782 12.419 40 20 40Z"
}, null, -1), h = /* @__PURE__ */ t("path", {
  fill: "#F0F0F0",
  d: "M26.956 23.913v-2.609h-1.739v-3.478l-1.739-1.739-1.739 1.74v-3.48L20 12.61l-1.738 1.739v3.478l-1.74-1.739-1.739 1.74v3.477h-1.739v2.609h-1.739v2.609h17.392v-2.609h-1.74Z"
}, null, -1), s = [
  n,
  c,
  h
];
function d(i, r) {
  return e(), l("svg", o, [...s]);
}
const a = { render: d };
export {
  a as default,
  d as render
};
